import {
  Card,
  Col,
  DatePicker,
  Flex,
  Form,
  FormProps,
  Input,
  notification,
  Row,
  Select,
  Table,
  TableColumnsType,
  TableProps,
} from 'antd';
import classNames from 'classnames';
import Title from 'antd/es/typography/Title';
import locale from 'antd/es/date-picker/locale/th_TH';
import { useState } from 'react';
import { formatDate, formatNumber } from '@/utilities/dataUtils';
import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import {} from '@/helpers/buyer';
import {
  // invoiceEntry,
  invoiceEntrys,
  // invoiceEntry,
  // invoiceEntrys,
  searchSellerInvoice,
} from '@/adapters/seller';
import {
  ISellerSearchInvoiceRes,
  ISellerSearchInvoiceReq,
  IInvoiceSendPprompbiz,
} from '@/interfaces/seller';
import {
  getSellerInvoiceStatusColor,
  getSellerInvoiceStatusName,
  getSellerInvoiceStatusOptions,
} from '@/helpers/seller';
import CustomerSelector from '@/components/selector/customer-selector';
import { ICustomer } from '@/interfaces/customer';
import dayjs from 'dayjs';
import { getServerInfo } from '@/adapters/misc';
import { IServerInfoRes } from '@/interfaces/misc';
import { ESellerInvoiceStatus } from '@/enums/seller';
import { getQueryParam } from '@/utilities/queryUtils';
import { jobProcess } from '@/adapters/job';

const { RangePicker } = DatePicker;

const _criteria: ISellerSearchInvoiceReq = {
  docNo: '',
  dateFrom: null,
  dateTo: null,
  customer: undefined,
  status: ESellerInvoiceStatus.PENDING,
};

const InvoicePage: React.FC = () => {
  const job = getQueryParam('job');
  const [form] = Form.useForm();
  const [criteria, setCriteria] = useState<ISellerSearchInvoiceReq>({
    ..._criteria,
  });

  const [selectedRowKey, setSelectedRowKey] = useState<IInvoiceSendPprompbiz[]>(
    []
  );

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 14 },
    },
  };

  const onFinish: FormProps<ISellerSearchInvoiceReq>['onFinish'] = (values) => {
    setCriteria({
      ...criteria,
      docNo: values.docNo,
      customer: values.customer,
      dateFrom:
        values?.dateFrom && dayjs(values?.dateFrom?.[0]).format('YYYY-MM-DD'),
      dateTo:
        values?.dateFrom && dayjs(values?.dateFrom?.[1]).format('YYYY-MM-DD'),
      status: values.status,
    });
  };

  const onClear = () => {
    form.setFieldsValue({
      ..._criteria,
    });
    setCriteria({
      ..._criteria,
    });
  };

  const columns: TableColumnsType<IInvoiceSendPprompbiz> = [
    {
      title: 'ลำดับ',
      dataIndex: '',
      width: 40,
      align: 'center',
      className: 'text-bold',
      render: (_, rec, i) => <div className="font-weight-bold">{i + 1}</div>,
    },
    {
      title: 'เลขที่เอกสาร',
      dataIndex: 'AR_INV',
      align: 'center',
      className: 'text-bold',
      width: 160,
    },
    {
      title: 'วันที่',
      dataIndex: 'AR_INV_DATE',
      align: 'center',
      className: 'text-bold',
      width: 160,
      render: (_) => formatDate(_),
    },
    {
      title: 'ประเภทเอกสาร',
      dataIndex: 'AR_TYPE',
      align: 'center',
      className: 'text-bold',
      width: 160,
    },
    {
      title: 'ลูกค้า',
      dataIndex: 'CUSTOMER',
      className: 'text-bold',
      align: 'center',
      width: 160,
    },
    {
      title: 'ชื่อลูกค้า',
      dataIndex: 'CUSTOMER_NAME',
      className: 'text-bold',
    },
    {
      title: 'ยอดเงิน',
      dataIndex: 'AR_INV_AMT',
      align: 'right',
      width: 160,
      className: 'text-bold text-primary',
      render: (_) => formatNumber(_, 2),
    },
    {
      title: 'เลขที่ PO',
      dataIndex: 'AR_PO',
      className: 'text-bold',
      width: 160,
      align: 'center',
    },
    {
      title: 'สถานะการส่ง',
      dataIndex: 'AR_MSTR_MESSSTATUS',
      align: 'center',
      width: 160,
      className: 'text-bold',
      render: (_) => (
        <div
          className={classNames(
            getSellerInvoiceStatusColor(_),
            'rounded pt-1 pb-1'
          )}
        >
          {getSellerInvoiceStatusName(_)}
        </div>
      ),
    },
  ];

  const rowSelection: TableProps<IInvoiceSendPprompbiz>['rowSelection'] = {
    onChange: (
      selectedRowKeys: React.Key[],
      selectedRows: IInvoiceSendPprompbiz[]
    ) => {
      setSelectedRowKey(selectedRows);
    },
    getCheckboxProps: (record: IInvoiceSendPprompbiz) => ({
      disabled: !!record.AR_MSTR_MESSID,
    }),
    selectedRowKeys: selectedRowKey?.map((c) => c.AR_INV),
  };

  const { data, refetch } = useQuery<
    AxiosResponse<ISellerSearchInvoiceRes>,
    Error
  >({
    queryKey: ['search-seller-inquiry', criteria],
    queryFn: async () => await searchSellerInvoice(criteria),
  });

  const { data: serverInfo } = useQuery<AxiosResponse<IServerInfoRes>, Error>({
    queryKey: ['search-server-info'],
    queryFn: async () => await getServerInfo(),
  });

  const mutations = useMutation({
    mutationFn: async (data: IInvoiceSendPprompbiz[]) =>
      await invoiceEntrys(data),
    // mutationFn: async (data: IInvoiceSendPprompbiz) => await invoiceEntry(data),
    mutationKey: ['invoice-entry'],
    onSuccess: (data) => {
      if (data.status === 200) {
        notification.success({
          message: 'ส่งเอกสารสำเร็จ',
        });
        refetch();
        setSelectedRowKey([]);
      }
    },
    onError: (error) => {
      console.log('error', error);
    },
  });

  function onEntry(): void {
    mutations.mutateAsync(selectedRowKey);
  }

  const invoices = data?.data?.data || [];

  return (
    <>
      <Flex justify="space-between" gap={2}>
        <div>
          <Title level={2} className="text-center">
            {serverInfo?.data?.data?.[0]?.SERVER_NAME}
          </Title>
        </div>
        <div>
          <Title
            level={2}
            className="text-center"
            onClick={() => (job === 'x12' ? jobProcess('invoice') : undefined)}
          >
            ค้นหาเอกสารใบแจ้งหนี้
          </Title>
        </div>
      </Flex>
      <Card>
        <Form
          {...formItemLayout}
          layout={'horizontal'}
          form={form}
          initialValues={{
            ...criteria,
            // docDate: [criteria.startDate, criteria.endDate],
          }}
          onFinish={onFinish}
          autoComplete="off"
          labelAlign={'left'}
        >
          <Row gutter={24}>
            <Col md={12}>
              <Form.Item name="docNo" label="เลขที่เอกสาร">
                <Input placeholder="เลขที่เอกสาร" size="large" />
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item<ISellerSearchInvoiceReq>
                name={'dateFrom'}
                label="วันที่เอกสาร"
              >
                <RangePicker
                  size="large"
                  style={{ width: '100%' }}
                  locale={locale}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col md={12}>
              <Form.Item<ISellerSearchInvoiceReq>
                name="customer"
                label="ลูกค้า"
              >
                <CustomerSelector
                  handleSelectData={function (customer: ICustomer): void {
                    form.setFieldsValue({
                      customer: customer?.CMAD_ID,
                    });
                  }}
                />
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item<ISellerSearchInvoiceReq> name="status" label="สถานะ">
                <Select
                  allowClear
                  options={getSellerInvoiceStatusOptions()}
                  placeholder="เลือกสถานะ"
                  size="large"
                />
              </Form.Item>
            </Col>
          </Row>
          <Flex gap={24} justify="center">
            <button
              disabled={!selectedRowKey.length || mutations.isPending}
              type="button"
              className="btn btn-success"
              style={{ minWidth: 150 }}
              onClick={() => onEntry()}
            >
              {mutations.isPending ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span className="sr-only">Loading...</span>
                </>
              ) : (
                'ส่งเอกสาร'
              )}
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              style={{ minWidth: 150 }}
            >
              ค้นหา
            </button>
            <button
              type="button"
              className="btn btn-danger"
              style={{ minWidth: 150 }}
              onClick={onClear}
            >
              ยกเลิก
            </button>
          </Flex>
        </Form>
      </Card>
      <Card className="mt-3">
        <Table<IInvoiceSendPprompbiz>
          rowSelection={{ type: 'checkbox', ...rowSelection }}
          columns={columns}
          dataSource={invoices}
          size="small"
          bordered
          rowKey={'AR_INV'}
          pagination={{
            total: invoices?.length || 0,
            showTotal: (total) => `${total} รายการ`,
            showSizeChanger: true,
            locale: { items_per_page: '/หน้า' },
          }}
          locale={{
            emptyText: 'ไม่พบรายการ',
          }}
        />
      </Card>
    </>
  );
};

export default InvoicePage;
